import { useLanguage } from 'app/contexts/LanguageContext';

export const getDisplayByEnumKey = (translations, map, status) => {
    if (status === undefined || status === "") {
        return "Unknown";
    }

    let transalationKey = map[status];
    if (transalationKey != undefined) {
        return translations[transalationKey]();
    } else {
        return "unknown";
    }
};

const useTranslations = () => {
    const { selectedLanguage } = useLanguage();

    const translate = (zh, en) => (selectedLanguage === 'zh' ? zh : en);
    const translateObj = (obj) => {
        if (!obj) { return ""; }
        let zhVal = (obj.zh) ? obj.zh : "";
        let enVal = (obj.en) ? obj.en : "";

        return (selectedLanguage === 'zh') ? zhVal : enVal;
    };

    const translateObj2 = (obj, key) => {
        if (!obj) { return ""; }
        let zhVal = (obj[key + "_zh"]) ? obj[key + "_zh"] : "";
        let enVal = (obj[key + "_en"]) ? obj[key + "_en"] : "";

        return (selectedLanguage === 'zh') ? zhVal : enVal;
    };

    return {
        i18nObj: (obj) => translateObj(obj),
        i18nObj2: (obj, key) => translateObj2(obj, key),
        showErrMsg: (messageObj) => translate(messageObj.message, messageObj.message_en),
        showSuccessMsg: (messageObj) => translate(messageObj.message, messageObj.message_en),
        translate,
        getRoleName: (item) => translate(item.role_name, item.role_name_en),
        rolemanage: () => translate('角色管理', 'Role Management'),
        role_t: () => translate('角色', 'Roles'),
        func_t: () => translate('功能', 'Function(s)'),
        role_edit: () => translate('編輯', 'Edit'),
        role_Add: () => translate('新增', 'Add'),
        role_delete: () => translate('刪除', 'Delete'),
        role_next: () => translate('下一頁', 'Next'),
        role_previous: () => translate('上一頁', 'Previous'),
        change_pass: () => translate('更改密碼', 'Change Password'),
        change_self_pass: () => translate('修改密碼', 'Change Password'),
        user_manage: () => translate('使用者管理', 'User Management'),
        availableuser: () => translate('可登入', 'Available'),
        usersearch: () => translate('搜尋', 'Search'),
        usercateg: () => translate('常用資源管理', 'User Defined Categories'),
        usertype: () => translate('類别', 'Type'),
        descCh: () => translate('描述', 'Description (Chinese)'),
        incenter: () => translate('戶內', 'In-Center'),
        venuech: () => translate('地點', 'Venue (Chinese)'),
        username: () => translate('用戶名單', 'User Name'),
        pushtiitle: () => translate('主題', 'Title'),
        pushnotiification: () => translate('推播通知管理', 'Push Notification'),
        pushstatus: () => translate('狀況', 'Status'),
        to: () => translate('至', 'To'),
        approvedby: () => translate('核准人', 'Approved By'),
        createdate: () => translate('建立日期', 'Create Date'),
        createmsg: () => translate('建立訊息', 'Create New Message'),
        pushdate: () => translate('推送日期', 'Push Date'),
        editby: () => translate('編輯者', 'Edit By'),
        lastupdate: () => translate('最後更新/批准', 'last Update/Approve'),
        pushreset: () => translate('重設', 'Reset'),
        nonotification: () => translate(' 沒有信息', ' No notification available'),
        reporttype: () => translate('報表類型', 'Report Type'),
        year: () => translate('年份', 'Year'),
        quater: () => translate('季度', 'Quater'),
        campaignname: () => translate('活動名稱', 'Campaign Name'),
        code: () => translate('活動编號', 'Code'),
        membermange: () => translate('會員管理', 'Member Management'),
        searchmember: () => translate('會員搜尋', 'Search for Member'),
        result: () => translate('結果', 'Result'),

        membername: () => translate('會員姓名', 'Member Name'),
        joineddate: () => translate('加入日期', 'Joined Date'),
        mobile: () => translate('登入手機號碼', 'Mobile Login ID'),
        memberid: () => translate('會員编號', 'Member ID'),
        cardref: () => translate('會員卡號', 'Card Ref'),
        app1st: () => translate('首次登入時間', 'App 1st Login'),
        memberidentity: () => translate('會員身份', 'Member Identity'),
        nomemberfound: () => translate('沒有找到會員', 'No Member Found'),

        basicinfo: () => translate('基本資料', 'Basic Information'),
        interests: () => translate('興趣', 'Interests'),
        memberdetails: () => translate('會員詳細資料', 'Member Details'),
        PasswordMEM: () => translate('密碼', 'Password'),
        recentdevice: () => translate('登入用的行動手機', 'Recent Devices'),
        deleteaccount: () => translate('刪除會員帳戶', 'Delete Account'),
        camaignengege: () => translate('活動參與', 'Campaign Engagement'),

        gender: () => translate('性別', 'Gender'),
        dobb: () => translate('出生日期', 'Birth Year and Month'),
        ageb: () => translate('年齡', 'Age'),
        joinb: () => translate('加入日期', 'Joined Date'),
        preferedlang: () => translate('首選語言', 'Prefered Language'),
        livindist: () => translate('居住地區', 'Living District'),
        livingzone: () => translate('居住地區', 'Living Zone'),
        savechaneg: () => translate('儲存變更', 'Save Changes'),
        cancel: () => translate('取消', 'Cancel'),

        interest: () => translate('興趣', 'Interest'),

        acting: () => translate('表演', 'Acting'),
        antiques: () => translate('古董', 'Antiques'),
        aquarium: () => translate('海洋', 'Aquarium'),
        art: () => translate('藝術', 'Art'),
        calligraphy: () => translate('書法', 'Calligraphy'),
        dancing: () => translate('舞蹈', 'Dancing'),
        design: () => translate('設計', 'Design'),
        fishing: () => translate('釣魚', 'Fishing'),
        gardening: () => translate('園藝', 'Gardening'),
        gourmand: () => translate('園藝', 'Gourmand'),
        history: () => translate('歷史', 'History'),
        it: () => translate('資訊科技', 'I.T'),
        languages: () => translate('語言', 'Languages'),
        music: () => translate('音樂', 'Music'),
        nurturing: () => translate('養生', 'Nurturing'),
        painting: () => translate('繪畫', 'Painting'),
        pets: () => translate('寵物', 'Pets'),
        photography: () => translate('攝影', 'Photography'),
        planting: () => translate('種植', 'Planting'),
        playing: () => translate('遊戲', 'Playing'),
        pottery: () => translate('陶器', 'Pottery'),
        reading: () => translate('閱讀', 'Reading'),
        sketching: () => translate('素描', 'Sketching'),
        sports: () => translate('運動', 'Sports'),
        taichi: () => translate('太極', 'Taichi'),
        travel: () => translate('旅行', 'Travel'),
        yoga: () => translate('瑜珈', 'Yoga'),


        memberDetails: () => translate('會員詳細資料', 'Member Details'),
        membershipLevel: () => translate('會員級別', 'Membership Level'),
        membershipIdentity: () => translate('會員身份', 'Membership Identity'),
        membershipStatus: () => translate('會員狀況', 'Membership Status'),
        opsCenter: () => translate('隸屬中心', 'Ops Center'),
        caregiver: () => translate('護老者', 'Caregiver'),
        volunteer: () => translate('義工', 'Volunteer'),
        addNewRelationship: () => translate('新增關係', 'Add New Relationship'),

        password: () => translate('密碼', 'Password'),
        newPassword: () => translate('新密碼', 'New Password'),
        confirmPassword: () => translate('確認密碼', 'Confirm Password'),
        createNewPasswordNextLogin: () => translate('會員登入時必須建立新密碼', 'Member must create new password at next login'),
        passwordRequirement: () => translate('密碼基本要求', 'Password Requirement'),
        ensureRequirementsMet: () => translate('確保滿足以下要求', 'Ensure that these requirements are met'),
        minimumCharacters: () => translate('至少八個字元長', 'Minimum 8 characters long'),
        oneLowercaseCharacter: () => translate('至少一個小寫字符', 'At least one lowercase character'),
        oneUppercaseCharacter: () => translate('至少一個大寫字符', 'At least one uppercase character'),
        oneNumber: () => translate('至少一個數字', 'At least one number'),


        instructorSetting: () => translate('導師設定', 'Instructor Setting'),
        instructorQualification: () => translate('導師專業資格', 'Instructor Qualification (Chinese)'),
        bio: () => translate('導師簡介', 'BIO (Chinese)'),
        addInstructorPhoto: () => translate('新增導師照片', 'Add Instructor Photo'),


        volunteerSetting: () => translate('義工設定', 'Volunteer Setting'),
        joinVoluntary: () => translate('加入義工行列', 'Join Voluntary'),
        willingToJoinVoluntary: () => translate('是的，會員願意自願加入', 'Yes, the member is willing to join voluntary'),
        interestAreaInVoluntary: () => translate('義工興趣領域', 'Interest Area in voluntary'),
        education: () => translate('教育', 'Education'),
        handcraft: () => translate('手工', 'Handcraft'),
        visit: () => translate('探訪', 'Visit'),
        community: () => translate('社區服務', 'Community Service'),
        environment: () => translate('環保', 'Environment'),
        health: () => translate('健康', 'Health'),
        animal: () => translate('動物保護', 'Animal'),
        periodMostLikelyToJoinVoluntaryActivityTimeOfDay: () => translate('最有可能參加活動的時段 :', 'Period most likely to join voluntary activity: Time of Day'),
        morning: () => translate('早上時段', 'morning'),
        afternoon: () => translate('下午時段', 'Afternoon'),
        evening: () => translate('傍晚時段', 'Evening'),
        periodMostLikelyToJoinVoluntaryActivityTimeOfWeek: () => translate('義工服務日子:', 'Period most likely to join voluntary activity: Time of week'),
        monday: () => translate('週一', 'Monday'),
        tuesday: () => translate('週二', 'Tuesday'),
        wednesday: () => translate('週三', 'Wednesday'),
        thursday: () => translate('週四', 'Thursday'),
        friday: () => translate('週五', 'Friday'),
        saturday: () => translate('週六', 'Saturday'),
        sunday: () => translate('週曰', 'Sunday'),
        publicHoliday: () => translate('法定假日', 'Public Holiday'),
        receivePromotion: () => translate('推廣頻道', 'Receive Promotion'),
        post: () => translate('郵寄', 'Post'),
        email: () => translate('電子郵件', 'Email'),
        mobileApp: () => translate('推播通知', 'Mobile App'),
        no: () => translate('不接受', 'No'),



        campaignEngagement: () => translate('活動參與', 'Campaign Engagement'),
        campaignDetails: () => translate('活動細節', 'Campaign Details'),
        inProgress: () => translate('正在參與的活動', 'In-Progress'),
        completed: () => translate('已完成的活動', 'Completed'),
        applicationStatus: () => translate('活動申請狀態', 'Application Status'),
        method: () => translate('報名方法', 'Method'),
        type: () => translate('類别', 'Type'),

        endDate: () => translate('結束日期', 'End Date'),
        every: () => translate('每', 'Every'),
        totalClasses: () => translate('總課程數', 'Total Classes'),
        attendance: () => translate('出席率', 'Attendance'),
        absence: () => translate('缺席', 'Absence'),
        reason: () => translate('缺席原因', 'Reason(s)'),


        recentDevices: () => translate('登入用的行動手機', 'Recent Devices'),
        device: () => translate('手機形號', 'Device'),
        location: () => translate('地區', 'Location'),
        recentActivity: () => translate('登入日期/時間', 'Recent Activity'),


        deleteAccount: () => translate('刪除帳戶', 'Delete Account'),
        deleteYourAccount: () => translate('刪除你的帳戶', 'Delete Your Account'),
        loseAccessToApp: () => translate('當您刪除帳戶時，您將無法登入手機App', 'When you delete your account, you lose access to the mobile App'),
        confirmDeleteAccount: () => translate('確認我要刪除我的帳戶', 'Confirm that I want to delete my account'),
        deletes: () => translate('刪除', 'Delete'),

        exactmatch: () => translate('正確配對', 'Exact Match'),
        attributename: () => translate('屬性名稱  ', 'Attribute Name'),
        condition: () => translate('狀態 ', 'Condition'),
        value: () => translate('數據值  ', 'Value'),
        removef: () => translate('移除  ', 'Remove '),
        addfilter: () => translate(' 新增篩選條件 ', 'Add Filter'),


        pushNotifications: () => translate('推播通知', 'Push Notifications'),
        addPhotoVideo: () => translate('新增照片/視頻', 'Add Photo/Video'),
        subtitle: () => translate('推播次標題', 'Subtitle (Chinese)'),
        messageContent: () => translate('訊息內容', 'Message Content (Chinese)'),
        sendDateTime: () => translate('發送日期和時間', 'Send Date and Time'),
        preview: () => translate('預覽', 'Preview'),
        test: () => translate('測試', 'Test'),
        scheduleAt: () => translate('安排在', 'Schedule At'),
        now: () => translate('現在', 'Now'),
        targetAudience: () => translate('目標對象', 'Target Audience'),
        allAppUsers: () => translate('所有手機App用户', 'All App Users'),
        paidUsersOnly: () => translate('收費會員', 'Paid Users Only'),
        guestOnly: () => translate('臨時會員', 'Guest Only'),
        confirm: () => translate('確認', 'Confirm'),
        save: () => translate('儲存', 'Save'),


        campaignManagement: () => translate('活動管理', 'Campaign Management'),
        campaignName: () => translate('活動名稱', 'Campaign Name'),
        startDate: () => translate('開始日期', 'Start Date'),
        pic: () => translate('負責人', 'PIC'),
        sis: () => translate('SIS', 'SIS'),
        createNewCampaign: () => translate('建立新活動', 'Create New Campaign'),
        details: () => translate('細節', 'Details'),
        copy: () => translate('複製', 'Copy'),




        basicInformation: () => translate('基本資料', 'Basic Information'),
        campaignNameChinese: () => translate('活動名稱', 'Campaign Name (Chinese)'),
        venueChinese: () => translate('地點', 'Venue (Chinese)'),
        quota: () => translate('活動名額', 'Quota'),
        inquiry: () => translate('負責人', 'Inquiry'),
        enrolmentMethod: () => translate('報名方式', 'Enrolment Method'),
        firstComeFirstServe: () => translate('先到先得', 'First come first serve'),
        lotteryDraw: () => translate('報名 / 抽籤', 'Registration / Lottery'),
        contactCounter: () => translate('請親身前往悠逸軒報名', 'Please register at YTNEC'),
        targetAudienceAndCourseFee: () =>
            translate('合資格會員和課程費用', 'Target Audience & Course Fee'),
        target: () => translate('對象', 'Target'),
        selectAudience: () => translate('會員類別', 'Select Audience'),
        fee: () => translate('費用', 'Fee'),
        publish: () => translate('發佈', 'Publish'),
        enablePublish: () =>
            translate(
                '開啟"發佈"功能, 合資格會員可以透過手機App查看和加入活動',
                'Enable "Publish" in the portal, and members can view and join the campaign from Mobile App'
            ),
        assignTo: () => translate('發送申請/批核', 'Assign To'),




        date: () => translate('日期', 'Date'),
        promotionStartDate: () => translate('推廣開始日期', 'Promotion Start Date'),
        promotionEndDate: () => translate('推廣結束日期', 'Promotion End Date'),
        registrationStartDate: () => translate('報名開始日期', 'Registration Start Date'),
        registrationEndDate: () => translate('報名結束日期', 'Registration End Date'),
        campaignStartDate: () => translate('活動開始日期', 'Campaign Start Date'),
        campaignEndDate: () => translate('活動結束日期', 'Campaign End Date'),
        Recurrence: () => translate('重覆日子', 'Recurrence'),


        instructor: () => translate('導師', 'Instructor(s)'),
        instructor2: () => translate('導師', 'Instructor'),
        addinstructor: () => translate('新增導師', 'Add Instructor'),


        lessonDetails: () => translate('課程詳情', 'Lesson Details'),
        lessonNameChinese: () => translate('課程名稱', 'Lesson Name (Chinese)'),
        lessonName: () => translate('課程名稱', 'Lesson Name'),
        startTime: () => translate('開始時間', 'Start Time'),
        endTime: () => translate('結束時間', 'End Time'),
        normal: () => translate('正常', 'Normal'),
        delayed: () => translate('延遲', 'Delayed'),
        cancelled: () => translate('取消', 'Cancelled'),



        uploadCampaignPhotoVideo: () =>
            translate('上傳活動照片/視頻', 'Upload Campaign Photo/Video'),
        addActivityPhotoVideo: () =>
            translate('新增活動照片/視頻', 'Add Activity Photo/Video'),
        addActivityIcon: () => translate('新增/更換活動圖片', 'Add / Replace Activity Icon'),


        survey: () => translate('問卷調查', 'Survey'),
        memberComments: () => translate('會員留言板', 'Member Comments'),
        enableUserComments: () =>
            translate(
                '開啟"留言板"功能, 合資格會員可以透過手機App寫入評語',
                'Enable User comments in the portal, and members can freely comment on the mobile App'
            ),



        consentForm: () => translate('同意書', 'Consent Form'),
        titleChinese: () => translate('主題', 'Title (Chinese)'),
        contentChinese: () => translate('內容', 'Content (Chinese)'),
        rule: () => translate('規則', 'Rule'),
        setConsentFormAsMandatory: () =>
            translate('同意書設為必填', 'Set Consent Form as Mandatory'),
        consentFormMandatory: () =>
            translate('付款前必須簽署同意書', 'Consent Form are Mandatory to sign and agree before payment'),



        enrolmentStatus: () => translate('活動註冊狀態', 'Enrolment Status'),
        noOfApplications: () => translate('申請人數', 'No. of applications'),
        quotaUsage: () => translate('占用率', 'Quota usage'),
        approver: () => translate('審批者姓名', 'Approver'),
        approver2: () => translate('註冊成功', 'Registered'),
        lastUpdate: () => translate('最後更新日期/時間', 'Last Update'),
        addMember: () => translate('新增會員', 'Add Member'),
        editMember: () => translate('編輯會員狀態', 'Edit Member'),
        addGroup: () => translate('新增群組', 'Add Group'),
        preApprove: () => translate('預先批核', 'Pre-approve'),
        approve: () => translate('批核完成', 'Approve'),
        waitlist: () => translate('候補', 'Waitlisted'),
        withdraw: () => translate('撤回', 'Withdraw'),


        attendanceDetails: () => translate('出席詳情', 'Attendance Details'),
        title: () => translate('活動名稱', 'Title'),
        dateStart: () => translate('日期 / 開始時間', 'Date/Start'),
        noOfAttendance: () => translate('總出席人數', 'No. of Attendance(s)'),
        noOfAbsentee: () => translate('總缺席人數', 'No. of Absentee(s)'),
        absenceReason: () => translate('缺席原因', 'Absence Reason'),
        close: () => translate('關閉', 'Close'),

        home: () => translate('首頁 - 儀表板', 'Home'),
        midentity: () => translate(' 身份搜尋', ' Identity'),
        mAdvance: () => translate(' 高諧搜尋', 'Advance '),
        searchformemberm: () => translate(' 會員搜尋', 'Search for Members'),

        period: () => translate('期間', 'Period'),
        mEdit: () => translate('編輯', 'Edit'),
        mAdd: () => translate('新增', 'Add'),
        mAddress: () => translate('地址', 'Address'),
        mEnglish: () => translate('英文', 'English'),
        mChinese: () => translate('中文', 'Chinese'),
        mMale: () => translate('男', 'Male'),
        mFemale: () => translate('女', 'Female'),
        instructorQualificationEn: () => translate('導師專業資格(英文)', 'Instructor Qualification (English)'),
        bioEn: () => translate('導師簡介(英文)', 'BIO (English)'),
        changeInstructorPhoto: () => translate('變更導師照片', 'Change Instructor Photo'),
        photoNotUpdateHint: () => translate('圖片尚未更新，請點擊\'儲存變更\'進行更新。', 'Image has not been updated. Please click \'Save Changes\' to update.'),
        campaignTypeMngmnt: () => translate('活動類型管理', 'Campaign Type Management'),
        campaignVenueMngmnt: () => translate('活動場地管理', 'Campaign Venue Management'),
        mFreeUser: () => translate('客席會員', 'Free'),
        mPaidUser: () => translate('有效會員', 'Paid'),
        mInitial: () => translate('初始會員', 'Initial'),
        mActive: () => translate('活躍會員', 'Active'),
        mSuspend: () => translate('失效會籍', 'Suspend'),
        mDeceased: () => translate('已故會員', 'Deceased'),
        mFunc: () => translate('功能', 'Function'),
        mUpdate: () => translate('更新', 'Update'),
        mQuestion: () => translate('問題', 'Question (English)'),
        mSend: () => translate('送出', 'Send'),
        mSuggestion: () => translate('建議', "Suggestion"),
        publishConfirm: () => translate('請注意: 活動發佈後，將無法再對其詳細信息進行任何編輯。請確保所有信息準確且完整後再繼續。', 'Warning: Once a campaign is published, you will not be able to make any further edits to its details. Please ensure all information is accurate and complete before proceeding.'),
        unPublishConfirm: () => translate('請注意: 目前已有會員註冊在這活動。請先把會員狀態更改為取消', 'Warning: There are members registered in this campaign, please change member status to Cancel'),
        publishError: () => ('請注意: 當前活動已结束', 'Error: Current campaign has ended'),
        unPublishError: () => ('請注意: 當前活動正在進行中，無法關閉', 'Error: Current campaign is in progress, and cannot be closed'),
        reminder: () => translate('提醒', 'Reminder'),
        none: () => translate('無', 'None'),
        checkedIn: () => translate('已報到', 'Checked-in'),
        inVocation: () => translate('請假', 'Leave'),
        notAttend: () => translate('未出席', 'Not Attended Yet'),
        signupSwitch: () => translate('報名開關', 'Registration Toggle'),
        inputType: () => translate('輸入類別', 'Select Type'),
        inputStatus: () => translate('輸入狀態', 'Select Status'),
        statusNormal: () => translate('正常狀態', 'Normal'),
        statusCancel: () => translate('被取消', 'Cancelled'),
        cmpgnStatusDraft: () => translate('草稿中', 'Draft'),
        cmpgnStatusPromotion: () => translate('推廣中', 'Promotion (Display)'),
        cmpgnStatusEnrolment: () => translate('活動報名中', 'Enrolment'),
        cmpgnStatusInProgress: () => translate('活動進行中', 'In-Progress'),
        cmpgnStatusSurvey: () => translate('學員回饋中', 'Survey'),
        fieldIsRequired: () => translate('缺少必填欄位', 'Missing required field(s)'),
        memberNotFound: () => translate('無此會員', 'Member not found'),
        loadMore: () => translate('載入更多', 'Load More'),
        unknownnSymbol: () => translate('---', '---'),
        copyCampaignConfirm: () => translate('確定複製這活動嗎? ', 'Confirm to replicate this campaign?'),
        commonConfirmMsg: () => translate('確定嗎 ? ', 'Are You Sure?'),
        unlockAcct: () => translate('帳戶解鎖', 'Unlock Account'),
        noOfApproval: () => translate('成功申請人數', 'No of approved'),
        userLogout: () => translate('登出', 'Logout'),
        logoutHint: () => translate('您確定要登出嗎？\n您的數據將被保留並可在下次登入時再次使用。', 'Are you sure you want to log out?\nYour data will be retained and can be used again the next time you log in.'),
        mOldPwd: () => translate('舊密碼', 'Old Password'),
        mNewPwd: () => translate('新密碼', 'New Password'),
        introductionChi: () => translate('介紹', 'Introduction (Chinese)'),
        mName: () => translate('名稱', 'Name'),
        selectVenue: () => translate('請選擇活動場地', 'Select Venue (Chinese)'),
        questionChi: () => translate('問題', 'Question (Chinese)'),
        draft: () => translate('Draft', 'Draft'),
        scheduled: () => translate('Scheduled', 'Scheduled'),
        sent: () => translate('Sent', 'Sent'),
        imageFileOnly: () => translate('僅接受圖片格式的上傳檔案', 'Only images are allowed.'),
        uploadPhotoVideo: () => translate('上傳照片/視頻', 'Upload Photo/Video'),
        linkButtonName: () => translate('連接按鈕名稱', 'Link Button Name'),
        linkButtonUrl: () => translate('連接按鈕連結', 'Link Button URL'),
        linkButtonNameEn: () => translate('連接按鈕名稱(English)', 'Link Button Name(English)'),
        linkButtonUrlEn: () => translate('連接按鈕連結(English)', 'Link Button URL(English)'),
        mFreeUser2: () => translate('客席會員', 'Free Member'),
        mPaidUser2: () => translate('有效會員', 'Paid Member'),
        confirmPushPublish: () => translate('確認推送推播', '確認推送推播'),
        confirmPushWithdraw: () => translate('確認撤回推播', '確認撤回推播'),
        createDraft: () => translate("建立草稿", "Create draft"),
        saveDraft: () => translate("保存草稿", "Save as draft"),
        mCardRef: () => translate("參考編號", "Card Reference"),
        startEndDateHint: () => translate("請選擇完整的日期範圍（開始與結束日期）。", "Please choose a complete date range (start and end dates)."),
        courseReasonEmptyHint: () => translate("請選擇狀況更改原因", "Please select reason "),
        copyPushConfirm: () => translate('確定複製這推播嗎? ', 'Confirm to replicate this Notification?'),
        campaignMediaLimitHint: () => translate('(最少一張, 最多三張)', '(Min 1 Photo. Max 3 photos)'),
        leavePageConfirm: () => translate('尚有未儲存的資料，確認是否離開此頁面？離開後此頁面資料將不會被保存', 'There are unsaved changes. Are you sure you want to leave this page? The data on this page will not be saved after leaving.'),
        appointedCaregiver: () => translate('指定照顧者 ', 'Appointed Caregiver'),
        appointedCaregiverSetting: () => translate('指定照顧者設定 ', 'Appointed Caregiver Setting'),
        identity: () => translate('身份', 'Identity'),
        autoRecurrence: () => translate('循環生成', 'Auto Recurrence'),
        daily: () => translate('每日', 'Daily'),
        weekly: () => translate('每週', 'Weekly'),
        monthly: () => translate('每月', 'Monthly'),
        lessonNameEnglish: () => translate('課程名稱 (英文)', 'Lesson Name (English)'),
        classNameEnglish: () => translate('課程名稱 (英文)', 'Class Name (English)'),
        venueEnglish: () => translate('地點 (英文)', 'Venue (English)'),
        recurrencePattern: () => translate('重複模式', 'Recurrence Pattern'),
        selectDaysOfWeek: () => translate('選擇星期', 'Select Days of Week'),
        selectMonths: () => translate('選擇月份', 'Select Months'),
        reasonForChange: () => translate('狀況更改原因', 'Reason'),
        createRecurrenceClasses: () => translate('創建重複課程', 'Create Recurrence Classes'),

        // Members Statistics (Dashboard)
        overview: () => translate('概述', 'Overview'),
        membersStatistics: () => translate('會員統計', 'Members'),
        seniors: () => translate('長者會員', 'Seniors'),
        preSeniors: () => translate('駿薈會員', 'Pre-seniors'),
        guestMembers: () => translate('客席會員', 'Guest members'),
        adults: () => translate('成人', 'Adult'),
        appointedCaregivers: () => translate('指定護老者', 'Appointed Caregivers'),
        volunteers: () => translate('義工', 'Volunteers'),
        caregivers: () => translate('護老者', 'Caregivers'),
        instructors: () => translate('導師', 'Instructors'),

        // Months
        monthApr: () => translate('四月', 'Apr'),
        monthMay: () => translate('五月', 'May'),
        monthJun: () => translate('六月', 'Jun'),
        monthJul: () => translate('七月', 'Jul'),
        monthAug: () => translate('八月', 'Aug'),
        monthSep: () => translate('九月', 'Sep'),
        monthOct: () => translate('十月', 'Oct'),
        monthNov: () => translate('十一月', 'Nov'),
        monthDec: () => translate('十二月', 'Dec'),
        monthJan: () => translate('一月', 'Jan'),
        monthFeb: () => translate('二月', 'Feb'),
        monthMar: () => translate('三月', 'Mar'),
        month: () => translate('月份', 'Month'),

        // App Usage
        appUsageTotal: () => translate('手機App用量統計', 'App Usage Total'),
        last7Days: () => translate('過去7天', 'Last 7 Days'),
        last30Days: () => translate('過去30天', 'Last 30 Days'),
        last90Days: () => translate('過去90天', 'Last 90 Days'),

        // Campaign Charts (Dashboard)
        completedCampaigns: () => translate('已完成的活動', 'Completed Campaigns'),
        openForRegistration: () => translate('報名中的活動', 'Open for Registration'),
        campaignInProgress: () => translate('正在進行中的活動', 'Campaign in progress'),
        q1: () => translate('季度1', 'Q1'),
        q2: () => translate('季度2', 'Q2'),
        q3: () => translate('季度3', 'Q3'),
        q4: () => translate('季度4', 'Q4'),
        aprJun: () => translate('4月至6月', 'Apr-Jun'),
        julSep: () => translate('7月至9月', 'Jul-Sep'),
        octDec: () => translate('10月至12月', 'Oct-Dec'),
        janMar: () => translate('1月至3月', 'Jan-Mar'),
        expandDetails: () => translate('詳細信息', 'Expand'),
        summaryUpToDate: () => translate('摘要（最新）', 'Summary (Up-to-date)'),
        totalCampaignsCreated: () => translate('年度內創建的活動總數', 'Total no. of campaigns created since start'),
        inProgressCampaigns: () => translate('進行中的活動', 'In-progress'),
        cancelledCampaigns: () => translate('被取消的活動', 'Cancelled Campaigns'),
        campaignInDraft: () => translate('未發佈的活動', 'Campaign in Draft'),
        upcomingCampaigns: () => translate('即將舉行的活動', 'Upcoming'),
        registrationClosed: () => translate('已截止報名的活動', 'Registration Closed'),
        totalReleasedCampaigns: () => translate('已發佈的活動總數', 'Total no. of released campaigns'),

        // Health Profile (Member Management)
        healthProfile: () => translate('健康檔案', 'Health Profile'),
        primaryBiometrics: () => translate('主要生物指標', 'Primary Biometrics'),
        height: () => translate('身高', 'Height'),
        weight: () => translate('體重', 'Weight'),
        oxygenSaturation: () => translate('血氧飽和度', 'Oxygen Saturation'),
        bloodPressure: () => translate('血壓', 'Blood Pressure'),
        recentMeasurementLog: () => translate('最近量度記錄', 'Recent Measurement Log'),
        filterBy: () => translate('篩選', 'Filter by'),
        year: () => translate('年份', 'Year'),
        date: () => translate('日期', 'Date'),
        time: () => translate('時間', 'Time'),
        oxygenSatAndPulse: () => translate('血氧飽和度及脈搏', 'Oxygen Saturation & Pulse'),
        bloodPressureAndPulse: () => translate('血壓及脈搏', 'Blood Pressure & Pulse'),
        noMeasurementData: () => translate('沒有量度記錄', 'No measurement records'),
    };
};

export default useTranslations;
